export default "https://cdn-static.gokick.com/assets/392c20f622263512bf2611e9ba1d645afacce893/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";